import React from 'react';
import { Lightbulb, Mail, Phone, Facebook, Linkedin, Instagram } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-column footer-brand">
            <div className="footer-logo">
              <Lightbulb size={32} />
              <span>LookApp</span>
            </div>
            <p className="footer-description">
              Profesionalna edukacija i savjetovanje za vaš uspjeh. Individualni pristup koji donosi rezultate.
            </p>
            <div className="footer-social">
              <a href="#" className="social-link" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="#" className="social-link" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
              <a href="#" className="social-link" aria-label="Instagram">
                <Instagram size={20} />
              </a>
            </div>
          </div>

          <div className="footer-column">
            <h4 className="footer-title">Usluge</h4>
            <ul className="footer-links">
              <li><a onClick={() => scrollToSection('services')}>Poduka matematika/fizika</a></li>
              <li><a onClick={() => scrollToSection('services')}>MS Excel edukacija</a></li>
              <li><a onClick={() => scrollToSection('services')}>Web Development</a></li>
              <li><a onClick={() => scrollToSection('services')}>Pisanje životopisa</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-title">Navigacija</h4>
            <ul className="footer-links">
              <li><a onClick={() => scrollToSection('hero')}>Početna</a></li>
              <li><a onClick={() => scrollToSection('about')}>O nama</a></li>
              <li><a onClick={() => scrollToSection('portfolio')}>Iskustvo</a></li>
              <li><a onClick={() => scrollToSection('testimonials')}>Preporuke</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-title">Kontakt</h4>
            <ul className="footer-contact">
              <li>
                <Mail size={18} />
                <a href="mailto:luka.postruzin9@gmail.com">luka.postruzin9@gmail.com</a>
              </li>
              <li>
                <Phone size={18} />
                <a href="tel:+385913653328">+385 91 365 3328</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} LookApp - obrt za poduku i savjetovanje. Sva prava pridržana.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
